module.exports = __webpack_public_path__ + "img/trevor-pro.6dac4b18.jpg";